import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {LOTTERY_PRIZE_TYPE_V} from '@src/constants';
import LotteryController from './LotteryController'
import {deepClone} from '@src/utils';

class LotteryStore extends StoreExt {
    @observable lock: boolean = false // 锁，防止同时点击
    @observable rotateNum: number = 1 // 第几次旋转
    @observable startRotateDeg: number = 0 // 开始旋转的角度
    @observable lotteryInfo: any
    @observable isDraw: boolean = false
    @observable noDrawInfo: any // 未中奖信息
    @observable drawInfo: any // 中奖信息
    @observable showModal: boolean = false
    @observable userLotteryInfo: any // 用户中奖信息
    @observable winDrawPrizeList: any[] = [] // 中奖用户轮播列表
    @observable move: number = 0 // 滚动距离
    private BASE_TIME = 6500   // 转动时间
    private lotteryController: LotteryController = new LotteryController('lottery-pointer')
    @action
    getLotteryInfo = async () => {
        try {
            const res = await this.api.queryLuckDrawInfo({})
            res.actInfoList = res.descr ? res.descr.split('\n') : []
            runInAction(() => {
                this.lotteryInfo = res
            })
        } catch (e) {
            console.error(e)
        }
    }
    /**
     * @returns {Promise<boolean>}
     * code: 10001(没有抽奖次数)
     * code: 10002(奖品剩余数量为0)
     * code: 10003(重复抽奖)
     */
    @action
    doSpin = async () => {
        // 无抽奖次数
        if (Number(this.lotteryInfo.balanceTimes) <= 0) {
            this.showModal = true
            this.isDraw = false
            this.noDrawInfo = this.formatNoTimesInfo()
            return false
        }
        // 活动到期
        if (new Date(this.lotteryInfo.endTime).getTime() < new Date().getTime()) {
            this.showModal = true
            this.isDraw = false
            this.noDrawInfo = this.formatOutDateInfo()
            return false
        }
        // 奖品抽完
        if (this.lotteryInfo.prizeBalanceCount <= 0) {
            this.showModal = true
            this.isDraw = false
            this.noDrawInfo = this.formatNoGiftInfo()
            return false
        }
        try {
            // 如果锁了（已经在转动），禁止再次点击
            if (this.lock) {
                return
            }
            const res = await this.api.doLottery({activityId: this.lotteryInfo.activityId})
            let lotteryGiftIndex = null
            if (res.state === '0') {
                lotteryGiftIndex = 5  // 未中奖，序号设置为5
            } else {
                this.lotteryInfo.activityPrizeList.map((item, index) => {
                    if (res.prizeId === item.prizeId) {
                        lotteryGiftIndex = index
                    }
                })
            }
            this.lock = true
            this.lotteryController.doLottery(lotteryGiftIndex)
            setTimeout(async () => {
                runInAction(() => {
                    this.drawInfo = res
                    this.showModal = true
                    this.isDraw = res.state === '1'
                    if (res.state === '0') {
                        this.noDrawInfo = this.formatNoDrawInfo()
                    }
                })
                this.lock = false
                // 如果中了优惠券，调接口领取优惠券
                if (res.state === '1' && res.prizeType === LOTTERY_PRIZE_TYPE_V.CHEAPER_COUPON) {
                    await this.api.receiveCoupons({activityId: res.activityId, discountId: res.discountId})
                }
                // 如果是套餐，调接口兑换套餐
                if (res.state === '1' && res.prizeType === LOTTERY_PRIZE_TYPE_V.DATA_PLAN) {
                    await this.api.goodsReleasePolicy({
                        activityId: res.activityId,
                        goodsReleaseId: res.goodsReleaseId
                    })
                }
                await this.getLotteryInfo()
            }, this.BASE_TIME + 200)  // 转结束后，放开锁
        } catch (e) {
            this.lock = false
            if (e.err.code === '10001') {
                this.showModal = true
                this.isDraw = false
                this.noDrawInfo = this.formatNoTimesInfo()
                return false
            }
            if (e.err.code === '10002') {
                this.showModal = true
                this.isDraw = false
                this.noDrawInfo = this.formatNoGiftInfo()
                return false
            }
            if (e.err.code === '10003') {
                this.$toast.info('请勿重复抽奖！')
                return false
            }
        }
    }
    @action
    resetRotate = () => {
        this.lotteryController.setStartRotateDegree(0)
    }
    @action
    handleClick = async (phone) => {
        if (!this.isDraw) {
            this.showModal = false
        } else {
            // 优惠券
            if (this.drawInfo.prizeType === LOTTERY_PRIZE_TYPE_V.CHEAPER_COUPON) {
                this.showModal = false
                this.goToPath('/app/home')
            }
            // 套餐
            if (this.drawInfo.prizeType === LOTTERY_PRIZE_TYPE_V.DATA_PLAN) {
                this.showModal = false
                this.goToPath('/app/mine/package/list')
            }
            // 积分
            if (this.drawInfo.prizeType === LOTTERY_PRIZE_TYPE_V.INTEGRAL) {
                this.showModal = false
            }
            // 实物
            if (this.drawInfo.prizeType === LOTTERY_PRIZE_TYPE_V.MATERIAL) {
                if (!phone) {
                    this.$toast.fail('请输入手机号')
                    return false
                } else {
                    await this.api.saveLinkPhone({phone: phone, drawId: this.drawInfo.drawId})
                    this.$toast.info('提交成功')
                    runInAction(() => {
                        this.showModal = false
                    })
                }
            }
        }
    }
    @action
    handleClose = () => {
        this.showModal = false
    }
    // 用户中奖信息
    @action
    getUserLotteryInfo = async () => {
        try {
            const res = await this.api.getUserDrawInfo({})
            runInAction(() => {
                this.userLotteryInfo = res
            })
        } catch (e) {
        }
    }
    // 获取中奖用户轮播列表
    @action
    getWinDrawPrizeList = async activityId => {
        try {
            const res = await this.api.winDrawPrizeList({activityId})
            runInAction(() => {
                this.list = res
                this.winDrawPrizeList = res
            })
        } catch (e) {
            console.error(e)
        }
    }
    // 未中奖
    private formatNoDrawInfo = () => {
        return {
            modalTitle: '很遗憾，未中奖',
            subTitle: '摇一摇最重要的是开心咯',
            btnText: '我知道了'
        }
    }
    // 活动到期信息提示
    private formatOutDateInfo = () => {
        return {
            modalTitle: '活动已结束啦',
            subTitle: '下次活动等你来参加哦',
            btnText: '我知道了'
        }
    }
    // 没有抽奖次数信息提示
    private formatNoTimesInfo = () => {
        return {
            modalTitle: '抽奖次数用完啦',
            subTitle: '你已经没有抽奖次数啦',
            btnText: '我知道了'
        }
    }

    // 奖品抽完了
    private formatNoGiftInfo = () => {
        return {
            modalTitle: '奖品抽完啦',
            subTitle: '下次活动等你来参加哦',
            btnText: '我知道了'
        }
    }
}

const lotteryStore = new LotteryStore()
export {lotteryStore, LotteryStore}
